import React from 'react';
import { Button, Grid, GridItem, Header3Text, ModalWindow, BodyText } from 'ui-toolkit';
import SwitchDialogWindows from '../../../../../shared/SwitchDialogWindows';
import { SpruceHelpInlineLink } from 'ui-toolkit';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/types';
import { deleteHoaDetailsSlice, getHoaDetailsAction } from '../../../../../../store/order/orderHoa/slices';
import { useAppDispatch } from '../../../../../../store/store';
import { useSelectCurrentOrder } from '../../../../../../selectors/order/selectCurrentOrder';

interface IDeleteHoaModalContainerProps {
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteHoaModalContainer: React.FC<IDeleteHoaModalContainerProps> = ({ onClose, onDelete }) => {
  const hoaAction = useSelector((state: RootStore) => state.order.hoa.deleteHoaDetailsSlice);
  const dispatch = useAppDispatch();
  const orderId = useSelectCurrentOrder().data.transaction.id!;

  const successMessage = (
    <Grid textAlign={'center'}>
      <Header3Text>HOA has been deleted!</Header3Text>
    </Grid>
  );

  const onCloseClick = () => {
    dispatch(deleteHoaDetailsSlice.actions.reset({}));
    dispatch(getHoaDetailsAction(orderId));
    onClose();
  };

  return (
    <SwitchDialogWindows
      updating={hoaAction.fetchStatus.fetching}
      processingTitle={'Working...'}
      updated={hoaAction.fetchStatus.fetched}
      error={hoaAction.fetchError && hoaAction.fetchError.message}
      successTitle={''}
      successMessage={successMessage}
      errorTitle={
        <Header3Text>
          HOA was not deleted. Visit <SpruceHelpInlineLink /> to submit a request for help.
        </Header3Text>
      }
      onCancelClick={onCloseClick}
      defaultDialogComponent={
        <ModalWindow uitype={'fit'} title={`Delete HOA`} onClose={onCloseClick}>
          <Grid columnCount={4}>
            <GridItem columnStart={`span 4`}>
              <BodyText>Are you sure you want to delete this HOA?</BodyText>
            </GridItem>
            <Button intent={'danger'} onClick={onDelete} data-test-id={`confirm-delete`}>
              Delete
            </Button>
            <Button intent={'secondary'} onClick={onCloseClick}>
              Cancel
            </Button>
          </Grid>
        </ModalWindow>
      }
    />
  );
};
